module.exports = __webpack_public_path__ + "static/media/3.a29e5d7b.png";